import { features } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-2">
          平台优势
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          为什么百万吃瓜群众选择黑料718作为首选入口
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 max-w-6xl mx-auto">
          {features.map((feature, i) => (
            <div
              key={i}
              className="text-center p-5 rounded-lg bg-background-50 border border-background-200/70"
            >
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-lg bg-primary-50">
                <i className={`text-xl text-primary-500 ${feature.icon}`}></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}